const migrationObatKFA = (state = [], action) => {
  switch (action.type) {
    case 'GET_MIGRATION_OBAT_KFA':
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};

const migrationCountStatus = (state = [], action) => {
  switch (action.type) {
    case 'GET_MIGRATION_OBAT_KFA_COUNT_STATUS':
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};

const migrationObatKFATotalPage = (state = 0, action) => {
  switch (action.type) {
    case 'GET_TOTAL_PAGE_MIGRATION_OBAT_KFA':
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};

const logMigrationObatKFA = (state = [], action) => {
  switch (action.type) {
    case 'GET_LOG_MIGRATION_OBAT_KFA':
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};

export { migrationObatKFA, migrationObatKFATotalPage, migrationCountStatus, logMigrationObatKFA };
